import React from 'react';

import { GradeFormComp } from 'pages/logistica/grade/components/pages/GradeForm';
import { GradeImportacaoComp } from 'pages/logistica/grade/components/pages/GradeImportacao';
import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { GradeExclusaoComp, GradeListComp } from 'pages/logistica/grade/components';

export function GradeList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['GRADE_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <GradeListComp />
        </ListagemProvider>
    );
}

export function GradeForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['GRADE_GERENCIAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <GradeFormComp />
        </FormProvider>
    );
}

export function GradeImportacao() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['GRADE_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <FormProvider>
                <GradeImportacaoComp />
            </FormProvider>
        </ListagemProvider>
    );
}

export function GradeExclusao() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['GRADE_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <GradeExclusaoComp />
        </ListagemProvider>
    );
}
